import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeEvacuationDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-evacuation',
  templateUrl: './type-evacuation.component.html',
  styleUrls: ['./type-evacuation.component.css']
})
export class TypeEvacuationComponent implements OnInit, OnDestroy {

  @Select(ControlPanelStore.typesEvacuations$) typesEvacuations$: Observable<TypeEvacuationDto[]>;
  public TypeEvacuationInComponent: TypeEvacuationDto;

  TypesEvacuation: TypeEvacuationDto[] = [];
  private _typeEvacuationId: number = null;

  @Input()
  get typeEvacuationId() {
    return this._typeEvacuationId;
  }
  set typeEvacuationId(val) {
    this._typeEvacuationId = val;
    this.getTypeEvacuationInComponent();
  }

  private p: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.p = this.typesEvacuations$.subscribe(res => {
      if (res != null) {
        this.TypesEvacuation = res;
        this.getTypeEvacuationInComponent(); 
      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

  getTypeEvacuationInComponent() {
    let typesEvacuations = this.TypesEvacuation.filter(p => p.Id == this.typeEvacuationId);
    this.TypeEvacuationInComponent = typesEvacuations.length == 1 ? typesEvacuations[0] : { Identifiant: null };
  }
}
